// Module
var code = "<fieldset class=\"dialog-warning-box\"> <legend>Warning</legend> <div class=\"dialog-warning-content\"> <ul> <li ng-repeat=\"paragraph in $ctrl.paragraphs\"> <i ng-if=\"$index==0\" class=\"fa-light fa-triangle-exclamation warning-icon\"></i> {{paragraph}} </li> </ul> </div> </fieldset> ";
// Exports
export default code;